import React from 'react'

function UploadVideo() {
    return (
        <div>
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" width="30" height="30" x="0" y="0" viewBox="0 0 24 24" xmlSpace="preserve" fillRule="evenodd" className="">
                <g>
                    <path d="M20.75 8.828c0-.729-.29-1.428-.805-1.944l-3.829-3.829a2.752 2.752 0 0 0-1.944-.805H8A4.75 4.75 0 0 0 3.25 7v10A4.75 4.75 0 0 0 8 21.75h8A4.75 4.75 0 0 0 20.75 17V8.828zm-6.5-5.076-.078-.002H8A3.247 3.247 0 0 0 4.75 7v10A3.25 3.25 0 0 0 8 20.25h8A3.25 3.25 0 0 0 19.25 17V8.828l-.002-.078H17c-.729 0-1.429-.29-1.945-.805A2.755 2.755 0 0 1 14.25 6zm3.939 3.498L15.75 4.811V6A1.252 1.252 0 0 0 17 7.25z" fill="#e3cefe" opacity="1" data-original="#000000" className=""></path>
                    <path d="M12 9.25h.018a.767.767 0 0 1 .199.032l.002.001a.738.738 0 0 1 .311.187l2 2a.749.749 0 1 1-1.06 1.06l-.72-.719V15a.75.75 0 0 1-1.5 0v-3.189l-.72.719a.749.749 0 1 1-1.06-1.06l2-2a.738.738 0 0 1 .311-.187l.002-.001a.767.767 0 0 1 .199-.032z" fill="#e3cefe" opacity="1" data-original="#000000" className=""></path>
                </g>
            </svg>
        </div>
    )
}

export default UploadVideo
